module.exports = __webpack_public_path__ + "img/tablet-neck-8_36x434.3894c63d.png";